// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy_privacy__3ss61","main":"privacy_main__JAtbM","main__subHeading":"privacy_main__subHeading__1gpm_","policy":"privacy_policy__19d4h"};